export default __webpack_public_path__ + "static/media/Photo 7 - MR - plan mal orienté.8791236a.jpg";